/**
 * Hardcoded DonorSearch profile ID overrides for specific contacts of org 429.
 * Returns the override profile ID if the contact matches, otherwise null.
 */
const getProfileIdOverride = (contactId) => {
  const id = Number(contactId);
  if (id === 12289675) return 1452568103;
  if (id === 12289716) return 1452569482;
  return null;
};

export default getProfileIdOverride;
